import {domain} from 'ferries/helpers/common';

export const LOCALES = ['el_GR', 'en_IE'];
export const API_URL = `${domain}/api/v1/ferries/autocomplete/fallback`;
export const GREEK_LANGUAGE_REGEX = /^[\u0370-\u03FF\u1F00-\u1FFF]/;
